import { render } from "./GM.vue?vue&type=template&id=77ad545a&scoped=true"
import script from "./GM.vue?vue&type=script&lang=js"
export * from "./GM.vue?vue&type=script&lang=js"

import "./GM.vue?vue&type=style&index=0&id=77ad545a&scoped=true&lang=css"
import "./GM.vue?vue&type=style&index=1&id=77ad545a&lang=css"
script.render = render
script.__scopeId = "data-v-77ad545a"

export default script